import { AttachmentComponent } from './attachments/attachment.component';
import { BasicInformationComponent } from './basic-information/basic-information.component';
import { ItemVendorComponent } from 'src/app/modules/mypurchase-form/item-vendor/item-vendor.component';
import { ReferenceComponent } from './reference/reference.component';
import { AddItemPageComponent } from './item-vendor/item-list/add-item/add-item-page.component';
export {
  AttachmentComponent,
  BasicInformationComponent,
  ItemVendorComponent,
  ReferenceComponent,
  AddItemPageComponent

};
